import HeaderContent from "../header_content";
import router from "@/router";

const getTargetComponent = (component: any, path: string) => {
  switch (path) {
    case "/signalMapping":
      return component;
    case "/seatMapping":
      return component;
    default:
      return component.$children[0];
  }
};

export function clearReloadEvents(self: HeaderContent) {
  const currentRoutePass = router.currentRoute.path;
  const parentComponent = self.$parent;
  let childrenComponent: any[];
  if (currentRoutePass === "/signalMapping" || currentRoutePass === "/seatMapping") {
    childrenComponent = parentComponent.$children[1].$children;
    childrenComponent.shift();
  } else {
    childrenComponent = parentComponent.$children[1].$children[0].$children;
  }
  childrenComponent.forEach((component: any) => {
    const targetComponent = getTargetComponent(component, currentRoutePass);
    if (typeof targetComponent.$data.reloadEvent !== "undefined") {
      clearInterval(targetComponent.$data.reloadEvent);
    }
  });
}
